import { Col, Row } from "react-bootstrap";
import {
  errorRed,
  netural400,
  neturalBlack,
  primaryOrange,
  success700,
} from "../../constants/color";
import DropDwonWithPaginationHeader from "../drop-down-with-pagination-header/drop-down-with-pagination-header.component";
import LoadingSpinner from "../shared/loading-spinner/loading-spinner.component";
import { Link } from "react-router-dom";
import ReportListHeader from "../report-list-header/report-list-header.component";
import CustomLabel from "../shared/label/custom-label.component";
import { ReactComponent as NoSalesImage } from "../../assets/report.svg";
import { STATUS_LABELS } from "../../constants/constant";

const ReportListCard = ({
  totalCount,
  reportList,
  page,
  type,
  setType,
  setPage,
  totalPages,
  pageSize,
  loading,
  search,
  dropDownValue,
}) => {
  // Calculate SR_NO for each record
  const calculateSR_NO = (recordIndex) => {
    return (page - 1) * pageSize + recordIndex + 1;
  };

  return (
    <div
      style={{
        marginTop: "3%",
        backgroundColor: "white",
        width: "100%",
        borderRadius: "12px",
        paddingBottom: "1%",
      }}
    >
      <DropDwonWithPaginationHeader
        type={type}
        setType={setType}
        loading={loading}
        dropDownValue={dropDownValue}
        totalCount={totalCount}
        page={page}
        pageSize={pageSize}
        setPage={setPage}
        totalPages={totalPages}
      />
      {search && search.trim().length == 0 && totalCount === 0 ? null : (
        <ReportListHeader type={type} />
      )}
      {loading ? (
        <div style={{ marginTop: "4%" }}>
          <LoadingSpinner overlay={false} />
        </div>
      ) : reportList.length === 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "2%",
          }}
        >
          <NoSalesImage />
          <label
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: neturalBlack,
              marginTop: "2%",
            }}
          >
            No reports
          </label>
          <label style={{ fontSize: "16px", color: netural400 }}>
            You do not have any reports at the moment.
          </label>
        </div>
      ) : search && search.trim().length != 0 && totalCount === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "3%",
          }}
        >
          <label
            style={{ fontSize: "18px", fontWeight: "600", color: neturalBlack }}
          >
            No {type} found
          </label>
        </div>
      ) : (
        reportList.map((data, index) => {
          return (
            <div
              style={{ marginTop: "2%", marginLeft: "1%", marginBottom: "2%" }}
            >
              <Row>
                <Col lg={1} md={1} sm={1} xs={1}>
                  <label style={{ fontSize: "16px" }}>
                    {calculateSR_NO(index)}
                  </label>
                </Col>
                <Col lg={3} md={3} sm={3} xs={3}>
                  <label style={{ fontSize: "16px" }}>{data.orderId}</label>
                </Col>
                <Col lg={2} md={2} sm={2} xs={2}>
                  <CustomLabel
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                      color:
                        data.status === "in_progress" ? errorRed : success700,
                      backgroundColor:
                        data.status === "in_progress" ? "#FDE7E7" : "#E6F6E6",
                      borderRadius: "12px",
                      padding: "0.5% 1%",
                    }}
                  >
                    {data.status === "resolved" ? STATUS_LABELS[data.status] : "In Progress"}
                  </CustomLabel>
                </Col>
                <Col lg={1} md={1} sm={1} xs={1}>
                  <label style={{ fontSize: "16px" }}>
                    {data.purchaseDate}
                  </label>
                </Col>
                <Col lg={2} md={2} sm={2} xs={2}>
                  <label style={{ fontSize: "16px" }}>{data.reportDate}</label>
                </Col>
                <Col lg={2} md={2} sm={2} xs={2}>
                  <label style={{ fontSize: "16px" }}>{data.clientName}</label>
                </Col>
                <Col lg={1} md={1} sm={1} xs={1}>
                  <Link
                    // to={
                    //   type === "Product"
                    //     ? `reportDetail/${data._id}`
                    //     : `reportDetail/${data._id}`
                    // }
                    to={`reportDetail/${data._id}`}
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: primaryOrange,
                      textDecoration: "none",
                    }}
                  >
                    View
                  </Link>
                </Col>
              </Row>
            </div>
          );
        })
      )}
    </div>
  );
};

export default ReportListCard;
